<template>
  <div class="group-setup">
    <v-progress-linear indeterminate color="orange" v-if="loading"></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2 orange--text">
          Project Information [{{ form.project_code }}]
        </h3>
        <v-spacer></v-spacer>
        <v-chip small>{{ form.status }}</v-chip>
        <v-spacer></v-spacer>
        <h3 v-if="form.club">Reported Club : {{ form.club.name }}</h3>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-form v-if="form" class="pa-5">
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Theme</div>
            <div class="caption" v-if="form.governor_theme">{{ form.governor_theme.theme }}</div>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Submitted Date</div>
            <div class="caption">{{ form.created_at }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Venue</div>
            <div class="caption">{{ form.venue }}</div>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Date</div>
            <div class="caption">{{ form.date }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Actual Total Project Cost</div>
            <div class="caption">Rs. {{ form.total_project_cost }}</div>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Direct Beneficiaries</div>
            <div class="caption">{{ form.direct_beneficiaries }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Indirect Beneficiaries</div>
            <div class="caption">{{ form.indirect_beneficiaries }}</div>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Project by Lion Ladies Association</div>
            <div class="caption">{{ form.is_lion_ladies ? 'Yes' : 'No' }}</div>
          </v-col>
          <v-col cols="6" md="6" sm="12"
            v-if="form.governor_theme && form.governor_theme.theme_key == 'environment'">
            <div class="subtitle-1">Tree Type</div>
            <div class="caption">{{ form.tree_type == 'SHORT_LIFESPAN' ? 'Short Lifespan (Vegetables)' : 'Long Lifespan (Teak, Coconut)' }}</div>
          </v-col>
          <v-col cols="6" md="6" sm="12"
            v-if="form.governor_theme && form.governor_theme.theme_key == 'promoting_tourism'">
            <div class="subtitle-1">Social Media Views</div>
            <div class="caption">{{ form.social_media_views }}</div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="12" sm="12">
            <div class="subtitle-1">Brief Description of the Project</div>
            <div class="caption">{{ form.description }}</div>
          </v-col>
          <v-col cols="12" md="12" sm="12" v-if="role === 'CLUBS_PERFORMANCE_EVALUATION'">
            <div class="subtitle-1">Video URL</div>
            <a v-if="form.video_url" :href="form.video_url" target="_blank"> {{ form.video_url }}</a>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">Billing Proof</div>
            <a :href="form.billing_proof_path" target="_blank"> View billing document</a>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <div class="subtitle-1">International Reporting Screenshot</div>
            <a :href="form.int_report_screenshot_path" target="_blank"> View international reporting</a>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
    </v-card>
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";

export default {
  name: "groupSetUpFrom",
  components: { Alert },
  props: ["uuid", "form"],
  data: () => ({
    role: localStorage.getItem("role") || null,
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    internationalThemes: [],
    regionList: [],
    codes: [
      {
        id: "SP",
        name: "Special Projects",
      },
      {
        id: "MP",
        name: "Mega Projects",
      },
      {
        id: "GP",
        name: "General Projects",
      },
      {
        id: "CP",
        name: "Continuous Project",
      },
      {
        id: "RP",
        name: "Region Project",
      },
      {
        id: "JRP",
        name: "Join Regions Project",
      },
    ],
  }),

  mounted() { },

  methods: {},
};
</script>
